import React from 'react';
import { EventObject } from '../../../types/types';
import { TableData } from '../../../components/utils/TableData';
import { DialogProperties, EventListType } from '../views/ListEventsPage';
import { ActionIcon } from './ActionIcon';

interface EventRowProps {
  id: string;
  headerKeys: string[];
  event: EventObject;
  open: (eventId: string, subEventId?: string) => void;
  toggleStatusChangeModal: (properties: DialogProperties) => void;
  type: EventListType;
}

export const EventTableRow: React.FC<EventRowProps> = ({
  event,
  headerKeys,
  id,
  open,
  toggleStatusChangeModal,
  type,
}) => {
  const rowStyles =
    'hover:text-blue-400 flex flex-col flex-nowrap md:table-row mb-2 md:mb-0';

  return (
    <>
      <tr className={rowStyles}>
        {headerKeys.map((key, i) => {
          const value = event[key];
          return <TableData key={i} value={value} open={open} id={id} />;
        })}
        <ActionIcon
          type={type}
          id={id}
          toggleStatusChangeModal={toggleStatusChangeModal}
        />
      </tr>
    </>
  );
};

export default EventTableRow;
